import Editor from './editor';
import md from '../../../const/meta/catalogs';

export default {
  Editor,
  md: md.kdbs,
};
